import { createSlice } from '@reduxjs/toolkit';

import { TranslationResult } from './types';
import { translateMessage, changeLanguage, hideTranslationById } from './actions';

export interface TranslationsState {
    messages: TranslationResult[];
    targetLanguage: string;
}

const initialState: TranslationsState = {
    messages: [],
    targetLanguage: '',
};

const translationsSlice = createSlice({
    name: 'translations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(translateMessage.pending, (state, { meta }) => {
            if (!state.messages.some((item) => item.id === meta.arg.id)) {
                state.messages = [...state.messages, { id: meta.arg.id }];
            }
        });
        builder.addCase(translateMessage.fulfilled, (state, { payload }) => {
            const index = state.messages.findIndex((item) => item.id === payload.id);
            state.messages[index] = payload;
        });

        builder.addCase(changeLanguage, (state, { payload }) => {
            const index = state.messages.findIndex((item) => item.id === payload.id);
            state.messages[index] = { ...state.messages[index], ...payload };
            state.targetLanguage = payload.targetLanguage;
        });

        builder.addCase(hideTranslationById, (state, { payload }) => {
            state.messages = state.messages.filter((item) => item.id !== payload);
        });
    },
});

export default translationsSlice.reducer;
